<template>
  <b-alert 
    show 
    variant="danger"
  >
    <i class="fa fa-exclamation-triangle" /> {{ item.toelichting }}
  </b-alert>
</template>
<script>
export default {
  name: "ChecklistItemTypeE",
  props: {
    onderdeel: {
      type: Object,
      required:true
    },
    item: {
      type:Object,
      required:true
    }
  },
  data() {
    return {
      jaar: null
    }
  },
  methods: {
    jaarChanged() {
      this.onderdeel.jaar = this.jaar - 10;
    }
  }
};
</script>
